import { getRegisterFunction } from '../../utils/register.js';
import { OneUxWidgetButtonElement } from './OneUxWidgetButtonElement.js';
export const register = getRegisterFunction(OneUxWidgetButtonElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-widget-button': OneUxWidgetButtonElement;
    "widget-button-eecf84449b04416416c352c242eda7a1": OneUxWidgetButtonElement;
  }
}